import { Box, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";
import theme from "../../../../theme";
import { convertPxToRem } from "../../../../utils";
import IconLoader from "@/features/Common/components/IconLoader";

interface MembershipDependentsSummaryProps {
  dependentsCount: number;
}

export default function MembershipDependentsSummaryV2({
  dependentsCount,
}: MembershipDependentsSummaryProps) {
  const { t } = useTranslation();
  const badgeOffsetLeft = theme.spacing(-2);

  return (
    <>
      {dependentsCount > 0 && (
        <Stack
          component="article"
          aria-label={t("MembershipDependentsSummary.label")}
          direction="row"
          alignItems="flex-start"
          width="100%"
          spacing={3}
        >
          <Box position="relative">
            <IconLoader
              icon="PeopleCardIcon"
              sx={{
                fontSize: convertPxToRem(45),
                color: theme.palette.accent5.main,
              }}
            />
            <Box
              bgcolor="accent5.lighter"
              sx={{
                position: "absolute",
                bottom: `${convertPxToRem(3.5)}`,
                right: `-${convertPxToRem(1)}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: theme.spacing(2.25),
                height: theme.spacing(2.25),
                borderRadius: "50%",
                fontSize: convertPxToRem(10),
                fontWeight: 700,
                lineHeight: 1,
              }}
            >
              <Typography
                variant="body1"
                fontWeight="bold"
                color="accent5.main"
              >
                {dependentsCount}
              </Typography>
            </Box>
          </Box>
          <Typography
            variant="h5"
            alignSelf="center"
            sx={{
              position: "relative",
              left: badgeOffsetLeft,
            }}
          >
            {dependentsCount > 1
              ? t("MembershipDependentsSummary.peopleCount.title", {
                  count: dependentsCount,
                })
              : t("MembershipDependentsSummary.personCount.title")}
          </Typography>
        </Stack>
      )}
    </>
  );
}
